export default {
    normal: { url: "line_stroke/line_stroke_normal", name: "normal" },
    dashed: { url: "line_stroke/line_stroke_dashed", name: "dashed" },
    dotted: { url: "line_stroke/line_stroke_dotted", name: "dotted" },
    squared: { url: "line_stroke/line_stroke_squared", name: "squared" },
}
